import styled from 'styled-components'

export const WrapperCenter = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
